(function(module) {
    'use strict';

    function EditScheduleCtrl($timeout, $scope, $state, $stateParams, Includes, App, Store, Schedule, $mdDialog, AppStylesInPlaylist, Group, Display, Playlist, scheduleSavePayload) {

        this.setDefault = () => {
            this.mode = $stateParams.route;
            this.scheduleId = $stateParams.id;
            this.checked = false;
            this.selectedIndex = 0;
            this.selectedItems = [];
            // this.appPreview = false;
            this.currentView = 'apps'; // apps/schedules/preview

            this.orientation = 'landscape';
            this.selectedAll = false;
            this.flex1 = 50;
            this.flex2 = 50;
            this.changeArrow = false;
        };

        this.getData = () => {
            if (this.mode === 'edit') {
                Promise
                    .all([
                        this.findSchedule(this.scheduleId),
                        this.getApps(),
                        this.getPlaylists(),
                    ])
                    .then(([schedule, apps, playlists]) => {
                        this.loading = false;

                        //SCHEDULE
                        this.schedule = Store.setSingleModelData('schedules', schedule.id, schedule);

                        this.selectedItems = this.schedule.items;

                        //SELECTED MD TAB
                        if (this.schedule.type === 'basic') {
                            this.selectedIndex = 0;
                        }
                        if (this.schedule.type === 'advanced') {
                            this.selectedIndex = 1;
                        }

                        //APPS
                        this.apps = Store.setMultiModelData('apps', apps);
                        this.playlists = Store.setMultiModelData('playlists', playlists);
                        // this.selectedItems = AppStylesInPlaylist.getAppStylesInPlaylist(this.schedule.apps, apps);

                        // set preview app
                        const appId = _.get(this, 'schedule.apps[0].id');
                        if (appId) {
                            const app = Store.getSingleModelData('apps', appId);

                            this.selectedItems.forEach((selectedApp) => {
                                if (selectedApp.id === appId) {
                                    selectedApp.active = true;
                                }
                            });

                            this.selectPreviewApp(app, app.appTemplate);
                        } else {
                            this.disablePreview = true;
                        }
                    });
            }

            if (this.mode === 'add') {
                this
                    .getApps()
                    .then((apps) => {
                        this.apps = Store.setMultiModelData('apps', apps);
                    });

                this
                    .getPlaylists()
                    .then((playlists) => {
                        this.playlists = Store.setMultiModelData('playlists', playlists);
                    });
            }
        };

        this.$onInit = () => {
            this.setDefault();
            this.getData();
        };

        this.onSubAccountChange = () => {
            this.setDefault();
            this.getData();
        };

        this.collapse = () => {
            if (this.flex1 === 50) {
                this.changeArrow = true;
                this.flex1 = 30;
                this.flex2 = 70;
            } else {
                this.changeArrow = false;
                this.flex1 = 50;
                this.flex2 = 50;
            }
        };

        this.getApps = () => {
            return App
                .find({ filter: Includes.apps })
                .$promise;
        };

        this.getPlaylists = () => {
            return Playlist
                .find()
                .$promise;
        };

        this.findSchedule = (scheduleId) => {
            return Schedule
                .findById({ id: scheduleId })
                .$promise;
        };

        this.droppedFile = () => {
            this.form.$setDirty();
        };

        this.deleteById = ({ id }) => {
            return Schedule
                .removeById({ id })
                .$promise
                .then(() => {
                    return Store.removeSingleModelData('schedules', id);
                })
                .then(() => {
                    $state.go('root.schedules');
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.revert = () => {
            this.form.$setPristine();
            this.setDefault();
            this.getData();
        };

        this.addAppToSchedule = ({ id, name, appTemplate }) => {
            const app = {
                id,
                type: 'app',
                slug: appTemplate.slug,
                day: 'mon',
                hour: 0,
                min: 0,

                name,
                styles: appTemplate.styles,
            };
            this.selectedItems.push(app);
            this.form.$setDirty();
        };

        this.addPlaylistToSchedule = ({ id, name }) => {
            const playlist = {
                id,
                type: 'playlist',
                day: 'mon',
                hour: 0,
                min: 0,

                name,
            };
            this.selectedItems.push(playlist);
            this.form.$setDirty();
        };

        this.deleteItem = (deletedApp, index) => {
            this.selectedItems.splice(index, 1);
            this.form.$setDirty();

            this.apps.forEach((app) => {
                if (app.id === deletedApp.id) {
                    app.checked = false;
                }

            });

            if (!this.selectedItems.length) {
                this.currentView = 'apps';
                // this.appPreview = false;
            }
        };

        this.getItemDescription = item => {
            const name = (item.type === 'app' ? this.apps : this.playlists).find(({ id }) => id === item.id).name;
            return `${item.type} - ${name}`;
        };

        this.save = () => {
            // we only want to save to the DB, appId and the duration
            const payload = scheduleSavePayload.buildScheduleSavePayload(this.schedule, this.selectedItems);

            if (!this.schedule.id) {
                //add
                Schedule.create(payload)
                    .$promise
                    .then((schedule) => {
                        $state.go('root.schedules.edit', { id: schedule.id });
                    })
                    .catch((error) => {
                        console.error(error);
                        Raven.captureException(error);
                    });
            } else {
                Promise.all([this.findDisplaysUsingScheduleId(this.schedule.id), this.findGroupsUsingScheduleId(this.schedule.id)])
                    .then(([displaysUsingScheduleId, groupsUsingScheduleId]) => {
                        let displaysUsingScheduleIdCount = displaysUsingScheduleId && displaysUsingScheduleId.length;
                        let groupsUsingScheduleIdCount = groupsUsingScheduleId && groupsUsingScheduleId.length;
                        let modalTitle;
                        let modalConfirmationText;
                        let modalCancelText;
                        let modalConfirmText;
                        let confirmActionFunc;
                        let itemCount1;
                        let itemCount2;
                        this.saveChanges = () => {
                            Schedule.prototype$patchAttributes(
                                { id: this.schedule.id },
                                payload)
                                .$promise
                                .then(() => {
                                    this.form.$setPristine();
                                })
                                .catch((error) => {
                                    console.error(error);
                                    Raven.captureException(error);
                                });
                        };

                        if (displaysUsingScheduleIdCount > 0 || groupsUsingScheduleIdCount > 0) {
                            modalTitle = 'Any changes made now to this schedule wil be also applied to:';
                            itemCount1 = displaysUsingScheduleIdCount > 0 ? `${displaysUsingScheduleIdCount + ' of your displays'}` : null;
                            itemCount2 = groupsUsingScheduleIdCount > 0 ? `${groupsUsingScheduleIdCount + ' of your groups'}` : null;
                            modalConfirmationText = 'as the schedule is being used by the above.';
                            modalConfirmText = 'Apply changes';
                            modalCancelText = 'Cancel';
                            const modalTypeOverride = 'information';

                            confirmActionFunc = () => {
                                this.saveChanges();

                            };
                            $mdDialog.show({
                                locals: {
                                    title: modalTitle,
                                    confirmationText: modalConfirmationText,
                                    cancelText: modalCancelText,
                                    confirmText: modalConfirmText,
                                    itemCount1: itemCount1,
                                    itemCount2: itemCount2,
                                    modalTypeOverride: modalTypeOverride,
                                },
                                controller: ($scope, $mdDialog) => {
                                    $scope.cancel = () => {
                                        $mdDialog.hide();
                                    };
                                    $scope.confirm = () => {
                                        $scope.cancel();
                                        confirmActionFunc();
                                    };
                                },
                                controllerAs: '$ctrl',
                                bindToController: true,
                                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                                parent: angular.element('body'),
                                clickOutsideToClose: true,
                                escapeToClose: true,
                            });
                        } else {
                            this.saveChanges();
                        }
                    });
            }
        };

        this.findDisplaysUsingScheduleId = (scheduleId) => {
            return Display
                .find({
                    filter: {
                        where: { scheduleId },
                        fields: ['id'],
                    },
                })
                .$promise;

        };

        this.findGroupsUsingScheduleId = (scheduleId) => {
            return Group
                .find({
                    filter: {
                        where: { scheduleId },
                        fields: ['id'],
                    },
                })
                .$promise;
        };

        this.openDialog = (modalTitle, modalConfirmationText, modalCancelText, modalConfirmText, confirmActionFunc, itemCount1, itemCount2, id) => {
            $mdDialog.show({
                locals: {
                    title: modalTitle,
                    confirmationText: modalConfirmationText,
                    cancelText: modalCancelText,
                    confirmText: modalConfirmText,
                    itemCount1: itemCount1,
                    itemCount2: itemCount2,

                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        $scope.cancel();
                        confirmActionFunc(id);
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.delete = (id) => {
            //find displays using schedule
            //find groups using schedule

            Promise.all([this.findDisplaysUsingScheduleId(id), this.findGroupsUsingScheduleId(id)])
                .then(([displaysUsingScheduleId, groupsUsingScheduleId]) => {
                    let displaysUsingScheduleIdCount = displaysUsingScheduleId && displaysUsingScheduleId.length;
                    let groupsUsingScheduleIdCount = groupsUsingScheduleId && groupsUsingScheduleId.length;
                    let modalTitle;
                    let modalConfirmationText;
                    let modalCancelText;
                    let modalConfirmText;
                    let confirmActionFunc;
                    let itemCount1;
                    let itemCount2;

                    if (displaysUsingScheduleIdCount <= 0 && groupsUsingScheduleIdCount <= 0) {
                        modalTitle = 'Are you sure you want to permanently remove this schedule?';
                        modalConfirmText = 'Yes, remove';
                        modalCancelText = 'Cancel';
                        confirmActionFunc = (id) => {
                            this.deleteById({ id });
                        };

                    } else {
                        modalTitle = 'You can\'t delete this schedule as being used by :';

                        itemCount1 = displaysUsingScheduleIdCount > 0 ? `${displaysUsingScheduleIdCount + ' of your displays'}` : null;
                        itemCount2 = groupsUsingScheduleIdCount > 0 ? `${groupsUsingScheduleIdCount + ' of your groups'}` : null;

                        modalConfirmationText = 'Please make sure the schedule is not being used before deleting.';
                        modalCancelText = 'Ok, I understand';
                    }
                    this.openDialog(modalTitle, modalConfirmationText, modalCancelText, modalConfirmText, confirmActionFunc, itemCount1, itemCount2, id);
                });
        };

        this.onScheduleAppClicked = (appId) => {
            this.disablePreview = false;
            const app = Store.getSingleModelData('apps', appId);
            this.selectPreviewApp(app, app.appTemplate);
        };

        this.selectPreviewApp = (app, appTemplate) => {
            this.disablePreview = false;
            this.app = app;
            this.appTemplate = appTemplate;
            this.selectedItems.forEach((selectedApp) => {
                if (selectedApp.id === this.app.id) {
                    selectedApp.active = true;
                } else {
                    selectedApp.active = false;
                }
            });

            if (!$scope.$$phase) {
                $timeout(() => {
                    $scope.$apply();
                });
            }
        };

        this.pickMyApps = () => {
            // this.appPreview = false;
            this.currentView = 'apps';
        };

        this.pickMyPlaylists = () => {
            this.currentView = 'playlists';
        };

        this.showPreview = () => {
            // this.appPreview = true;
            this.currentView = 'preview';
            // reset preview to the first item in the schedule

            const appId = _.get(this, 'selectedItems[0].id');
            if (appId) {
                const app = Store.getSingleModelData('apps', appId);

                this.selectedItems.forEach((selectedApp, index) => {
                    if (selectedApp[index] === 0) {
                        selectedApp.active = true;
                    } else {
                        selectedApp.active = false;
                    }
                });

                this.selectPreviewApp(app, app.appTemplate);
            } else {
                this.disablePreview = true;
            }

        };
    }

    module
        .config(($stateProvider, $translatePartialLoaderProvider) => {
            $stateProvider
                .state('root.schedules.add', {
                    url: '/add',
                    data: {
                        pageTitle: 'SCHEDULES.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<edit-schedule-component />',
                        },

                    },
                    params: {
                        route: { value: 'add' },
                    },
                    bodyClass: 'page--add-schedule',
                })
                .state('root.schedules.edit', {
                    url: '/edit/:id',
                    data: {
                        pageTitle: 'SCHEDULES.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<edit-schedule-component />',
                        },
                    },
                    params: {
                        route: { value: 'edit' },
                    },
                    bodyClass: 'page--edit-schedule',
                });

            // Translations
            $translatePartialLoaderProvider.addPart('/js/schedules');

        })
        .component('editScheduleComponent', {
            templateUrl: '/js/schedules/edit-schedule/edit-schedule.html',
            controller: EditScheduleCtrl,
        });

})(angular.module('rocket.components'));
